module.exports = __webpack_public_path__ + "e4d99941cbd3328bc8de78948e9f7bbc.png";